import { LayoutComponent } from "@jelly/lesson";

import first_order_1 from "./first-order/first-order-1";
import first_order_2 from "./first-order/first-order-2";
import first_order_3 from "./first-order/first-order-3";
import first_order_4 from "./first-order/first-order-4";
import first_order_5 from "./first-order/first-order-5";
import first_order_6 from "./first-order/first-order-6";
import first_order_7 from "./first-order/first-order-7";
import first_order_8 from "./first-order/first-order-8";

const component: LayoutComponent = {
  variant: "layout",
  data: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [1, 15],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "<b>Construction of first order image sources</b>",
                  formatter: "html",
                  scrollbars: false,
                  styles: {
                    textAlign: "center",
                    textTransform: "uppercase",
                    fontSize: "14px",
                    fontWeight: 800,
                    letterSpacing: "3.5px",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "layout",
            data: {
              type: "carouselPaginated",
              options: {
                components: [
                  first_order_1,
                  first_order_2,
                  first_order_3,
                  first_order_4,
                  first_order_5,
                  first_order_6,
                  first_order_7,
                  first_order_8,
                ],
              },
            },
          },
        ],
      ],
    },
  },
};

export default component;
